import React, { Dispatch, SetStateAction } from "react";
import { Button, Caption1, Checkbox } from "@fluentui/react-components";
import { SecuritiesInList } from "../..";
import { SecuritiesIdentifiers } from "../options";
import useSecuritiesListStyles from "./securitiesList.styles";

interface SecuritiesInListProps {
  setSecuritiesInList: Dispatch<SetStateAction<SecuritiesInList>>;
  securitiesInList: SecuritiesInList;
  securitiesIdentifiers: SecuritiesIdentifiers;
  securitiesInListFiltered: SecuritiesInList;
}

enum SelectionType {
  Select = "select",
  Clear = "clear",
}

const SecuritiesList = ({
  setSecuritiesInList,
  securitiesInList,
  securitiesIdentifiers,
  securitiesInListFiltered,
}: SecuritiesInListProps) => {
  const styles = useSecuritiesListStyles();

  const handleSelection = (type: SelectionType) => {
    const securitiesInListCopy = { ...securitiesInList };

    Object.keys(securitiesInListCopy).forEach((isin) => {
      securitiesInListCopy[isin].isCheck = type === SelectionType.Select;
    });

    setSecuritiesInList(securitiesInListCopy);
  };

  return (
    <div>
      <div className={styles.selectionHeader}>
        <Caption1>
          {Object.keys(securitiesInList).filter((check) => securitiesInList[check].isCheck).length} items selected
        </Caption1>
        <div className={styles.selectionHeaderButtons}>
          <Button onClick={() => handleSelection(SelectionType.Clear)} size="small">
            Clear selection
          </Button>
          <Button onClick={() => handleSelection(SelectionType.Select)} size="small">
            Select all
          </Button>
        </div>
      </div>

      <div className={styles.checkboxesContainer}>
        {Object.keys(securitiesInListFiltered).length &&
          Object.keys(securitiesInListFiltered).map((isin) => {
            const security = securitiesInListFiltered[isin];

            return (
              <Checkbox
                key={`security-checkbox-${isin}`}
                checked={security.isCheck}
                label={security[securitiesIdentifiers.toLowerCase() as keyof typeof security] as string}
                onChange={() =>
                  setSecuritiesInList({
                    ...securitiesInList,
                    [isin]: {
                      ...security,
                      isCheck: !security.isCheck,
                    },
                  })
                }
              />
            );
          })}
      </div>
    </div>
  );
};

export default SecuritiesList;
